import React, { useState } from "react";
import { UserSearch } from "../../components/userSearch";
import AddressForm from "../../components/addAddress/addressForm";

export const Search = () => {
  const [showAddressForm, setShowAddressForm] = useState(false);

  return (
    <>
      <div className="flex flex-row justify-between gap-4">
        {/* Left Side: User Search */}
        <div className="w-full">
          <UserSearch setShowAddressForm={setShowAddressForm} />
        </div>

        {/* Right Side: Address Form (Only Shows When Needed) */}
        {showAddressForm && <AddressForm setShowAddressForm={setShowAddressForm} />}
      </div>
    </>
  );
};
